import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import { Logo } from 'shared/ui/logo';
import { Column, ProfileContainer, ProfilePopover, Wrapper } from './styles';
import { ProfileButton } from 'shared/ui/buttons/profileButton/profileButton';
import { useCallback, useRef, useState } from 'react';
import { useOutClick } from 'app/lib/hooks/useOutClick';
import { ModalProvider } from 'shared/ui/modal';
import { LogoutConfirm } from './logoutConfirm';

export const HeaderMobile = () => {
	const [isOpenProfile, setOpenProfile] = useState(false);
	const [isOpenConfirm, setOpenConfirm] = useState(false);
	const ref = useRef(null)

	const toggleProfile = useCallback(() => {
		setOpenProfile(prev => !prev);
	}, [])

	useOutClick(ref, () => setOpenProfile(false))

	return (
		<Wrapper>
			<Column>
				<Logo />
			</Column>
			<ProfileContainer ref={ref}>
				<ProfileButton onClick={toggleProfile}>A</ProfileButton>
				{isOpenProfile && (
					<ProfilePopover>
						<ButtonContained onClick={() => {
							setOpenConfirm(true);
							setOpenProfile(false);
						}}>
							Выйти из аккаунта
						</ButtonContained>
					</ProfilePopover>
				)}
			</ProfileContainer>
			{isOpenConfirm && (
				<ModalProvider openByDefault>
					<LogoutConfirm onClose={() => setOpenConfirm(false)} />
				</ModalProvider>
			)}
      {/* <DatePicker onChange={onDateChange} value={selectedTimeslot ? new Date(selectedTimeslot) : new Date()} />
      <CurrentTimeSwitch /> */}
		</Wrapper>
	);
};
